import { TextModalBodyProps } from './textModalBody.props';
import styles from './textModalBody.module.scss';

import { useEffect, useRef, useState } from 'react';
import { CloseButton } from 'components/elements/closeButton/CloseButton';

const policyText = document.getElementById('policy-text');
const rulesText = document.getElementById('rules-text');
const cookieText = document.getElementById('cookie-text');
const principlesText = document.getElementById('principles-text');
const requisitesText = document.getElementById('requisites-text');

export const TextModalBody = ({
  type,
  onClose,
}: TextModalBodyProps): JSX.Element => {
  const contentRef = useRef<HTMLDivElement>(null);

  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!contentRef.current) {
      return;
    }

    if (type === 'policy') {
      contentRef.current.innerHTML = policyText?.innerHTML ?? '';
      setTitle('Политика конфиденциальности');
    } else if (type === 'rules') {
      contentRef.current.innerHTML = rulesText?.innerHTML ?? '';
      setTitle('Пользовательское соглашение');
    } else if (type === 'cookie') {
      contentRef.current.innerHTML = cookieText?.innerHTML ?? '';
      setTitle('Политика использования cookie');
    } else if (type === 'principles') {
      contentRef.current.innerHTML = principlesText?.innerHTML ?? '';
      setTitle('Правила проживания');
    } else if (type === 'requisites') {
      contentRef.current.innerHTML = requisitesText?.innerHTML ?? '';
      setTitle('Реквизиты');
    }
  }, [type]);

  return (
    <div className={styles.module}>
      <CloseButton className={styles.close} onClick={onClose} />

      <h3 className={styles.title}>{title}</h3>
      <div className={styles.content} ref={contentRef} />
    </div>
  );
};
